/**
 * Inline API-error line for a save/refresh/regenerate/disconnect failure
 * within an option body or DNS panel footer. Same shape as
 * component/WidgetIndex/DeleteModal.jsx's failureBlock.
 */
import React from "react";
import Icon from "../../../theme/untitled/icons/Icon";
import styles from "./FieldError.module.scss";

const FieldError = ({ message }) => {
  if (!message) return null;

  return (
    <div className={styles.root}>
      <Icon name="AlertCircle" size={16} className={styles.icon} />
      <span className={styles.text}>{message}</span>
    </div>
  );
};

export default FieldError;
